import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Button } from '../components/ui/button';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '../components/ui/tabs';
import { LogOut, Package, ShoppingBag, Truck, Settings } from 'lucide-react';
import AdminOrders from '../components/admin/AdminOrders';
import AdminProducts from '../components/admin/AdminProducts';
import AdminDeliveryZones from '../components/admin/AdminDeliveryZones';
import AdminSettings from '../components/admin/AdminSettings';

const AdminDashboard = () => {
  const navigate = useNavigate();
  const { user, loading, logout } = useAuth();

  useEffect(() => {
    if (!loading && !user) {
      navigate('/admin/login');
    }
  }, [user, loading, navigate]);

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  if (loading || !user) {
    return (
      <div className="min-h-screen bg-[#FAF8F5] flex items-center justify-center">
        <p className="text-[#5C4247]">Carregando...</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#FAF8F5]">
      {/* Header */}
      <header className="bg-white border-b border-[#F3E8E3] sticky top-0 z-30">
        <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img src="/images/logo.png" alt="Petiscaria Camamu" className="h-12 w-12" />
            <div>
              <h1
                className="text-xl font-bold text-[#7F1D1D]"
                style={{ fontFamily: 'Outfit, sans-serif', letterSpacing: '-0.02em' }}
                data-testid="admin-header-title"
              >
                Painel Admin
              </h1>
              <p className="text-xs text-[#5C4247]" style={{ fontFamily: 'Manrope, sans-serif' }}>
                Petiscaria Camamu
              </p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <a
              href="/"
              className="text-sm text-[#5C4247] hover:text-[#7F1D1D] hidden sm:inline"
              data-testid="admin-view-site-link"
            >
              Ver site →
            </a>
            <Button
              onClick={handleLogout}
              variant="outline"
              className="border-[#7F1D1D] text-[#7F1D1D] hover:bg-[#7F1D1D] hover:text-white rounded-full"
              data-testid="admin-logout-button"
            >
              <LogOut className="h-4 w-4 mr-2" />
              Sair
            </Button>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-7xl mx-auto px-4 py-6">
        <Tabs defaultValue="orders" className="w-full">
          <TabsList className="grid w-full grid-cols-2 sm:grid-cols-4 mb-6 bg-white border border-[#F3E8E3] h-auto">
            <TabsTrigger value="orders" data-testid="tab-orders">
              <ShoppingBag className="h-4 w-4 mr-2" />
              Pedidos
            </TabsTrigger>
            <TabsTrigger value="products" data-testid="tab-products">
              <Package className="h-4 w-4 mr-2" />
              Produtos
            </TabsTrigger>
            <TabsTrigger value="delivery" data-testid="tab-delivery">
              <Truck className="h-4 w-4 mr-2" />
              Entrega
            </TabsTrigger>
            <TabsTrigger value="settings" data-testid="tab-settings">
              <Settings className="h-4 w-4 mr-2" />
              Configurações
            </TabsTrigger>
          </TabsList>

          <TabsContent value="orders">
            <AdminOrders />
          </TabsContent>
          <TabsContent value="products">
            <AdminProducts />
          </TabsContent>
          <TabsContent value="delivery">
            <AdminDeliveryZones />
          </TabsContent>
          <TabsContent value="settings">
            <AdminSettings />
          </TabsContent>
        </Tabs>
      </main>
    </div>
  );
};

export default AdminDashboard;
